import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ChangeRequestPreviewRoutingModule } from './change-request-preview-routing.module';
import { ChangeRequestPreviewComponent } from './change-request-preview.component';
import { DxScrollViewModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
import { PDFModule } from 'app/pdf/pdf.module';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule({
  imports: [
    CommonModule,
    ChangeRequestPreviewRoutingModule,
    I18nModule,
    PDFModule,
    FormsModule,
    DxScrollViewModule,
    NgxSpinnerModule
  ],
  declarations: [ChangeRequestPreviewComponent]
})
export class ChangeRequestPreviewModule { }
